/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.session

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecurringSchedule(
    val id: String,
    @SerialName("patient_id")
    val patientId: String,
    val frequency: RecurrenceFrequency,
    @SerialName("interval_days")
    val intervalDays: Int? = null,
    @SerialName("day_of_week")
    val dayOfWeek: Int,
    @SerialName("time_of_day")
    val timeOfDay: String? = null,
    val fee: Long,
    @SerialName("anchor_date")
    val anchorDate: String,
    @SerialName("is_active")
    val isActive: Boolean = true,
    @SerialName("created_at")
    val createdAt: String,
)
